<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="700px"
  >
    <template slot="dialogTitle">
      {{ pack.label }}
    </template>
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-simple-table>
        <thead>
          <tr>
            <th>
              Item
            </th>
            <th>
              Quantity
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in selectedItems"
            :key="'item_'+index"
          >
            <td>
              {{ item.label }}
            </td>
            <td>
              {{ item.quantity }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <div
        v-if="unselectedItems.length > 0"
        class="mt-6"
      >
        <v-subheader>
          Not Included
        </v-subheader>

        <v-simple-table style="opacity: 0.5">
          <thead>
            <tr>
              <th>
                Item
              </th>
              <th>
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in unselectedItems"
              :key="'item_unselected_'+index"
            >
              <td>
                {{ item.label }}
              </td>
              <td>
                {{ item.quantity }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card-text>
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Close
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
// import { cloneDeep } from 'lodash'
import ContentDialog from '@/components/helpers/Dialog'

export default {
    name: 'YachtEquipmentItemsDialog',
    components: {
      ContentDialog
    },
    props: {
      pack: {
        type: Object,
        required: true
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        saving: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          // if (!value) this.updateSpecifications()
          this.$emit('update:visible', value)
        }
      },
      selectedItems: function () {
        if (!this.pack.is_configurable) return this.pack.items

        return this.pack.items.filter(item => !!item.is_selected)
      },
      unselectedItems: function () {
        if (!this.pack.is_configurable) return []

        return this.pack.items.filter(item => !item.is_selected)
      }
    }
  }
</script>
